import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_card_products, get_wishlist_products } from '../store/reducers/cardReducer';
import horizontalLogo from '../assets/horizontal.png';
import { Search, Heart, User, Bag, Menu, Mail, Phone, Instagram, Facebook, TikTok, Check } from './home/ui';

const PROMO_ITEMS = [
    'Envío gratis en compras desde Q899',
    'Pagos seguros con tarjeta',
    'Atención al cliente WhatsApp · 9 a 21h',
    'Tienda en línea · envíos a todo Guatemala',
];

const SUB_LINKS = {
    alimento: ['Croquetas premium', 'Cachorro', 'Adulto', 'Senior', 'Snacks y premios', 'Alimento húmedo'],
    accesorios: ['Camas y mantas', 'Collares y correas', 'Juguetes', 'Transportadoras', 'Platos y bebederos'],
    cuidado: ['Plan veterinario', 'Higiene y baño', 'Antiparasitarios', 'Vitaminas', 'Estética y grooming'],
};

/* Mega panel that appears on hover */
const MegaPanel = ({ category }) => {
    if (!category) return null;
    return (
    <div
        className='bg-white border-t border-[#f1efea] py-7 px-0'
        style={{ boxShadow: '0 24px 50px -20px rgba(15,23,42,.18)' }}
    >
        <div className='max-w-[1320px] mx-auto px-6'>
            <div className='grid grid-cols-[1.2fr_1fr_1fr_1.2fr] gap-8 items-start'>

                {/* Featured tile */}
                <div className='bg-[#ecfeff] rounded-[14px] p-5 relative overflow-hidden'>
                    <span className='text-[10.5px] font-extrabold tracking-[.06em] uppercase text-[#0891b2]'>Destacado</span>
                    {category.image && (
                        <img src={category.image} alt={category.name} className='w-full h-[90px] object-cover rounded-[10px] my-3 opacity-80' />
                    )}
                    <h5 className='font-bold text-[#1e3a8a] text-[17px] leading-tight mb-2 tracking-tight' style={{ fontFamily: "'Bricolage Grotesque', system-ui, sans-serif" }}>
                        {category.name}
                    </h5>
                    <p className='text-[12.5px] text-[#64748b] mb-3 leading-relaxed'>Todo lo que tu compañero necesita al mejor precio.</p>
                    <Link
                        to={`/products?category=${category.name}`}
                        className='text-[12.5px] font-bold text-[#0891b2] inline-flex items-center gap-1'
                    >
                        Ver todo
                        <svg className='w-3 h-3' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
                    </Link>
                </div>

                {/* Alimento */}
                <div>
                    <h6 className='font-extrabold text-[#0f172a] text-[11.5px] tracking-[.08em] uppercase mb-3 pb-2 border-b border-[#f1efea]'>Alimento</h6>
                    <ul className='flex flex-col gap-2'>
                        {SUB_LINKS.alimento.map((item, i) => (
                            <li key={i}>
                                <Link to={`/products?category=${category.name}`} className={`text-[13.5px] ${i === 0 ? 'font-bold text-[#1e3a8a]' : 'font-medium text-[#334155]'} hover:text-[#0891b2] hover:translate-x-[2px] transition-all inline-flex items-center gap-1 py-[2px]`}>
                                    {i === 0 && <span className='text-[11px] mr-1'>🐾</span>}{item}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Accesorios */}
                <div>
                    <h6 className='font-extrabold text-[#0f172a] text-[11.5px] tracking-[.08em] uppercase mb-3 pb-2 border-b border-[#f1efea]'>Accesorios</h6>
                    <ul className='flex flex-col gap-2'>
                        {SUB_LINKS.accesorios.map((item, i) => (
                            <li key={i}>
                                <Link to={`/products?category=${category.name}`} className='text-[13.5px] font-medium text-[#334155] hover:text-[#0891b2] hover:translate-x-[2px] transition-all inline-flex items-center gap-1 py-[2px]'>
                                    {item}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Cuidado */}
                <div>
                    <h6 className='font-extrabold text-[#0f172a] text-[11.5px] tracking-[.08em] uppercase mb-3 pb-2 border-b border-[#f1efea]'>Cuidado</h6>
                    <ul className='flex flex-col gap-2'>
                        {SUB_LINKS.cuidado.map((item, i) => (
                            <li key={i}>
                                <Link to={`/products?category=${category.name}`} className={`text-[13.5px] ${i === 0 ? 'font-bold text-[#1e3a8a]' : 'font-medium text-[#334155]'} hover:text-[#0891b2] hover:translate-x-[2px] transition-all inline-flex items-center gap-1 py-[2px]`}>
                                    {i === 0 && <span className='text-[11px] mr-1'>🐾</span>}{item}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

            </div>
        </div>
    </div>
    );
};

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { categorys } = useSelector(state => state.home);
    const { userInfo } = useSelector(state => state.auth);
    const { card_product_count, wishlist_count } = useSelector(state => state.card);
    const { pathname } = useLocation();

    const [searchOpen, setSearchOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [category, setCategory] = useState('');
    const [mobileOpen, setMobileOpen] = useState(false);
    const [activeMega, setActiveMega] = useState(null);
    const megaTimerRef = useRef(null);
    const searchInputRef = useRef(null);
    const headerRef = useRef(null);

    useEffect(() => {
        if (userInfo) {
            dispatch(get_card_products(userInfo.id));
            dispatch(get_wishlist_products(userInfo.id));
        }
    }, [userInfo]);

    useEffect(() => {
        if (!searchOpen) return;
        const t = setTimeout(() => searchInputRef.current && searchInputRef.current.focus(), 120);
        // Como en el diseño: Escape o un clic fuera del header cierran la búsqueda.
        const onKey = (e) => { if (e.key === 'Escape') setSearchOpen(false); };
        const onClick = (e) => { if (headerRef.current && !headerRef.current.contains(e.target)) setSearchOpen(false); };
        document.addEventListener('keydown', onKey);
        document.addEventListener('mousedown', onClick);
        return () => {
            clearTimeout(t);
            document.removeEventListener('keydown', onKey);
            document.removeEventListener('mousedown', onClick);
        };
    }, [searchOpen]);

    const doSearch = () => {
        if (searchValue.trim()) {
            navigate(`/products/search?category=${category}&&value=${searchValue}`);
            setSearchOpen(false);
            setSearchValue('');
        }
    };

    const openMega = (id) => {
        clearTimeout(megaTimerRef.current);
        setActiveMega(id);
    };

    const closeMega = () => {
        megaTimerRef.current = setTimeout(() => setActiveMega(null), 120);
    };

    const keepMega = () => {
        clearTimeout(megaTimerRef.current);
    };

    /* First 2 categories get a mega panel, the rest are simple links */
    const validCats = categorys.filter(c => c && c.name);
    const megaCats = validCats.slice(0, 2);
    const simpleCats = validCats.slice(2, 6);

    const IconBtn = ({ onClick, badge, children, className = '', label }) => (
        <button
            onClick={onClick}
            aria-label={label}
            className={`relative w-[42px] h-[42px] rounded-full flex items-center justify-center text-[#0f172a] hover:bg-[#f5f1ea] hover:text-[#0891b2] transition-all ${className}`}
        >
            {children}
            {badge > 0 && (
                <span className='absolute top-[4px] right-[4px] min-w-[17px] h-[17px] rounded-full bg-[#0f172a] text-white text-[10px] font-bold flex items-center justify-center px-[4px] border-2 border-white leading-none'>
                    {badge}
                </span>
            )}
        </button>
    );

    return (
        <>

            {/* ── Promo strip ── */}
            <div className='bg-[#0f172a] text-white overflow-hidden'>
                <div
                    className='flex gap-[60px] py-[9px] whitespace-nowrap text-[12px] font-medium tracking-[.08em] uppercase'
                    style={{ animation: 'promoScroll 38s linear infinite', width: 'max-content' }}
                >
                    {[...PROMO_ITEMS, ...PROMO_ITEMS].map((text, i) => (
                        <span key={i} className='inline-flex items-center gap-[10px] flex-shrink-0'>
                            <Check className='w-[13px] h-[13px] text-white/55 flex-shrink-0' strokeWidth={1.6} />
                            {text}
                        </span>
                    ))}
                </div>
            </div>

            {/* ── Utility bar ── */}
            <div className='bg-[#f5f1ea] border-b border-[#e8e6e1] text-[12px] md-lg:hidden'>
                <div className='max-w-[1320px] mx-auto px-6'>
                    <div className='flex justify-between items-center h-9 text-[#5a4d3a]'>
                        <div className='flex items-center gap-[22px]'>
                            <a href="mailto:hola@senorbigotes.com" className='inline-flex items-center gap-[7px] font-medium hover:text-[#0f172a] transition-colors'>
                                <Mail className='w-3 h-3 opacity-70' />hola@senorbigotes.com
                            </a>
                            <a href="tel:5551234567" className='inline-flex items-center gap-[7px] font-medium hover:text-[#0f172a] transition-colors'>
                                <Phone className='w-3 h-3 opacity-70' />55 1234 5678
                            </a>
                        </div>
                        <div className='flex items-center gap-[22px]'>
                            <Link to='/sucursales' className='inline-flex items-center gap-[7px] font-medium hover:text-[#0f172a] transition-colors'>Sucursales</Link>
                            <Link to='/rastrear' className='inline-flex items-center gap-[7px] font-medium hover:text-[#0f172a] transition-colors'>Rastrea tu pedido</Link>
                            {userInfo
                                ? <Link to='/dashboard' className='inline-flex items-center gap-[7px] font-medium hover:text-[#0f172a] transition-colors'>
                                    <User className='w-3 h-3 opacity-70' strokeWidth={2.2} />{userInfo.name}
                                  </Link>
                                : <Link to='/login' className='inline-flex items-center gap-[7px] font-medium hover:text-[#0f172a] transition-colors'>
                                    Mi cuenta
                                  </Link>
                            }
                            <div className='flex items-center gap-3 border-l border-[#e8e6e1] pl-[18px]'>
                                <a href="#" aria-label='Instagram' className='opacity-65 hover:opacity-100 hover:text-[#0f172a] transition-opacity'><Instagram className='w-[14px] h-[14px]' /></a>
                                <a href="#" aria-label='Facebook' className='opacity-65 hover:opacity-100 hover:text-[#0f172a] transition-opacity'><Facebook className='w-[14px] h-[14px]' /></a>
                                <a href="#" aria-label='TikTok' className='opacity-65 hover:opacity-100 hover:text-[#0f172a] transition-opacity'><TikTok className='w-[14px] h-[14px]' /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Main header ── */}
            <header ref={headerRef} className='sticky top-0 z-50 bg-white/[.97] border-b border-[#e8e6e1]' style={{ backdropFilter: 'blur(16px)' }}>
                <div className='max-w-[1320px] mx-auto px-6'>

                    {/* Logo row */}
                    <div className='grid grid-cols-3 items-center gap-6 py-[18px] md-lg:py-[14px]'>
                        <div className='flex items-center'>
                            <span className='text-[11.5px] font-semibold tracking-[.18em] uppercase text-[#64748b] md-lg:hidden'>
                                Pet shop · Guatemala
                            </span>
                            <button
                                className='hidden md-lg:flex items-center justify-center w-[42px] h-[42px] rounded-full text-[#0f172a] hover:bg-[#f5f1ea]'
                                onClick={() => setMobileOpen(true)}
                                aria-label='Abrir menú'
                            >
                                <Menu className='w-5 h-5' />
                            </button>
                        </div>

                        <div className='flex justify-center'>
                            <Link to='/'>
                                <img src={horizontalLogo} alt="Señor Bigotes Pet Shop" className='h-[54px] w-auto' />
                            </Link>
                        </div>

                        <div className='flex items-center gap-1 justify-end'>
                            <IconBtn onClick={() => setSearchOpen(v => !v)} label='Buscar'>
                                <Search className='w-[19px] h-[19px]' />
                            </IconBtn>
                            <IconBtn
                                onClick={() => navigate(userInfo ? '/dashboard/my-wishlist' : '/login')}
                                badge={wishlist_count}
                                className='md-lg:hidden'
                                label='Favoritos'
                            >
                                <Heart className='w-[19px] h-[19px]' strokeWidth={1.6} />
                            </IconBtn>
                            {userInfo
                                ? <Link to='/dashboard' aria-label='Mi cuenta' className='relative w-[42px] h-[42px] rounded-full flex items-center justify-center text-[#0f172a] hover:bg-[#f5f1ea] hover:text-[#0891b2] transition-all md-lg:hidden'>
                                    <User className='w-[19px] h-[19px]' />
                                  </Link>
                                : <Link to='/login' aria-label='Ingresar' className='relative w-[42px] h-[42px] rounded-full flex items-center justify-center text-[#0f172a] hover:bg-[#f5f1ea] hover:text-[#0891b2] transition-all md-lg:hidden'>
                                    <User className='w-[19px] h-[19px]' />
                                  </Link>
                            }
                            <IconBtn
                                onClick={() => navigate(userInfo ? '/card' : '/login')}
                                badge={card_product_count}
                                label='Carrito'
                            >
                                <Bag className='w-[19px] h-[19px]' />
                            </IconBtn>
                        </div>
                    </div>

                    {/* Search overlay */}
                    <div
                        className={`absolute left-0 right-0 top-full z-[60] bg-white border-b border-[#e8e6e1] pt-7 pb-8 ${searchOpen ? 'translate-y-0 opacity-100 visible pointer-events-auto' : '-translate-y-3 opacity-0 invisible pointer-events-none'}`}
                        style={{
                            boxShadow: '0 24px 50px -24px rgba(15,23,42,.12)',
                            // visibility cambia al instante al abrir (para poder enfocar el input)
                            // y espera a que termine el fundido al cerrar.
                            transition: `opacity .25s cubic-bezier(.2,.8,.2,1), transform .25s cubic-bezier(.2,.8,.2,1), visibility 0s linear ${searchOpen ? '0s' : '.25s'}`,
                        }}
                    >
                        <div className='max-w-[1320px] mx-auto px-6'>
                            <div className='flex items-center gap-[14px] border-b-[1.5px] border-[#0f172a] pb-[10px]'>
                                <Search className='w-[22px] h-[22px] text-[#0f172a] flex-shrink-0' />
                                <input
                                    ref={searchInputRef}
                                    type="search"
                                    value={searchValue}
                                    onChange={e => setSearchValue(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && doSearch()}
                                    placeholder='¿Qué buscas para tu peludo?'
                                    className='flex-1 min-w-0 border-none outline-none text-[26px] md:text-[20px] font-medium text-[#0f172a] bg-transparent py-[6px] tracking-tight placeholder:text-[#94a3b8] placeholder:font-normal'
                                    style={{ fontFamily: "'Bricolage Grotesque', system-ui, sans-serif" }}
                                />
                                <button
                                    onClick={() => { setSearchOpen(false); setSearchValue(''); }}
                                    className='text-[12px] font-semibold tracking-[.12em] uppercase text-[#64748b] hover:text-[#0f172a] transition-colors px-2'
                                >
                                    Cerrar
                                </button>
                            </div>
                            {validCats.length > 0 && (
                                <div className='flex items-center gap-5 flex-wrap mt-4 text-[12.5px] text-[#64748b]'>
                                    <strong className='text-[#0f172a] font-bold tracking-[.08em] uppercase text-[11px]'>Categorías</strong>
                                    {validCats.slice(0, 6).map((c, i) => (
                                        <Link
                                            key={i}
                                            to={`/products?category=${c.name}`}
                                            onClick={() => setSearchOpen(false)}
                                            className='text-[#334155] hover:text-[#0891b2] transition-colors border-b border-transparent hover:border-[#0891b2] py-1'
                                        >
                                            {c.name}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                </div>

                {/* ── Mega nav ── */}
                <nav className='border-t border-[#e8e6e1] bg-white relative md-lg:hidden'>
                    <div className='max-w-[1320px] mx-auto px-6'>
                        <div className='flex items-center justify-center gap-1'>

                            {/* Categories with mega panel */}
                            {megaCats.map((c) => (
                                // Sin `relative`: el panel se ancla a la <nav> y ocupa todo su ancho.
                                <div
                                    key={c._id}
                                    onMouseEnter={() => openMega(c._id)}
                                    onMouseLeave={closeMega}
                                >
                                    <button className={`px-[18px] xl:px-[10px] py-[14px] text-[13px] xl:text-[12px] font-medium tracking-[.16em] xl:tracking-[.1em] uppercase whitespace-nowrap transition-colors flex items-center gap-1 ${activeMega === c._id ? 'text-[#0891b2]' : 'text-[#0f172a] hover:text-[#0891b2]'}`}>
                                        {c.name}
                                        <svg className='w-3 h-3 opacity-50' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                                    </button>

                                    {/* Mega dropdown */}
                                    <div
                                        onMouseEnter={keepMega}
                                        onMouseLeave={closeMega}
                                        className={`absolute top-full left-0 right-0 z-[100] transition-all duration-200 ${activeMega === c._id ? 'opacity-100 visible translate-y-0 pointer-events-auto' : 'opacity-0 invisible -translate-y-[6px] pointer-events-none'}`}
                                    >
                                        <MegaPanel category={c} />
                                    </div>
                                </div>
                            ))}

                            {/* Simple category links */}
                            {simpleCats.map((c) => (
                                <Link
                                    key={c._id}
                                    to={`/products?category=${c.name}`}
                                    className='px-[18px] xl:px-[10px] py-[14px] text-[13px] xl:text-[12px] font-medium tracking-[.16em] xl:tracking-[.1em] uppercase whitespace-nowrap text-[#0f172a] hover:text-[#0891b2] transition-colors'
                                >
                                    {c.name}
                                </Link>
                            ))}

                            {/* Static links */}
                            <span className='w-[1px] h-[12px] bg-[#e8e6e1] mx-[10px]'></span>
                            <Link to='/shops' className='px-[18px] xl:px-[10px] py-[14px] text-[13px] xl:text-[12px] font-medium tracking-[.16em] xl:tracking-[.1em] uppercase whitespace-nowrap text-[#0f172a] hover:text-[#0891b2] transition-colors'>
                                Marcas
                            </Link>
                            <Link to='/shops' className='px-[18px] xl:px-[10px] py-[14px] text-[13px] xl:text-[12px] font-medium tracking-[.16em] xl:tracking-[.1em] uppercase whitespace-nowrap text-[#0f172a] hover:text-[#0891b2] transition-colors'>
                                Veterinaria
                            </Link>
                            <Link
                                to='/shops'
                                className='px-[18px] xl:px-[10px] py-[14px] text-[13px] xl:text-[12px] font-semibold tracking-[.16em] xl:tracking-[.1em] uppercase whitespace-nowrap text-[#ef4444] hover:text-[#ef4444]/80 transition-colors inline-flex items-center gap-2'
                            >
                                <span className='w-[5px] h-[5px] rounded-full bg-[#f87171] inline-block animate-pulse'></span>
                                Promo 3×2
                            </Link>
                        </div>
                    </div>
                </nav>
            </header>

            {/* ── Mobile sidebar ── */}
            <div className='hidden md-lg:block'>
                <div
                    onClick={() => setMobileOpen(false)}
                    className={`fixed inset-0 bg-black/50 z-[9998] transition-opacity duration-200 ${mobileOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                />
                <div className={`fixed top-0 left-0 h-screen w-[300px] bg-white z-[9999] transition-transform duration-200 overflow-y-auto py-6 px-8 ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                    <div className='flex flex-col gap-6'>
                        <Link to='/' onClick={() => setMobileOpen(false)}>
                            <img src={horizontalLogo} alt="Señor Bigotes" className='h-[50px] w-auto' />
                        </Link>
                        {userInfo
                            ? <Link to='/dashboard' onClick={() => setMobileOpen(false)} className='flex items-center gap-2 text-sm text-[#0f172a] font-medium'>
                                <User className='w-4 h-4' /><span>{userInfo.name}</span>
                              </Link>
                            : <Link to='/login' onClick={() => setMobileOpen(false)} className='flex items-center gap-2 text-sm text-[#0f172a] font-medium'>
                                <User className='w-4 h-4' /><span>Ingresar</span>
                              </Link>
                        }

                        {/* Mobile nav: all categories */}
                        {validCats.length > 0 && (
                            <div>
                                <span className='text-[11px] font-extrabold tracking-[.1em] uppercase text-[#64748b] mb-2 block'>Categorías</span>
                                <ul className='flex flex-col gap-1'>
                                    {validCats.map((c) => (
                                        <li key={c._id}>
                                            <Link
                                                to={`/products?category=${c.name}`}
                                                onClick={() => setMobileOpen(false)}
                                                className='py-2 block text-sm font-semibold uppercase text-[#334155] hover:text-[#0891b2] transition-colors'
                                            >
                                                {c.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <ul className='flex flex-col gap-1 text-sm font-semibold uppercase text-[#334155] border-t border-[#f1efea] pt-4'>
                            <li><Link to='/shops' onClick={() => setMobileOpen(false)} className='py-2 block hover:text-[#0891b2]'>Tienda</Link></li>
                            <li><Link to='/shops' onClick={() => setMobileOpen(false)} className='py-2 block hover:text-[#0891b2]'>Marcas</Link></li>
                            <li><Link to='/shops' onClick={() => setMobileOpen(false)} className='py-2 block text-[#ef4444]'>Promo 3×2</Link></li>
                        </ul>

                        <div className='flex items-center gap-4 border-t border-[#f1efea] pt-4'>
                            <button
                                onClick={() => { navigate(userInfo ? '/dashboard/my-wishlist' : '/login'); setMobileOpen(false); }}
                                className='relative flex items-center justify-center w-[42px] h-[42px] rounded-full bg-[#f1f5f9] text-[#0891b2]'
                            >
                                <Heart className='w-[18px] h-[18px]' />
                                {wishlist_count > 0 && <span className='absolute -top-[3px] -right-[5px] w-5 h-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center'>{wishlist_count}</span>}
                            </button>
                            <button
                                onClick={() => { navigate(userInfo ? '/card' : '/login'); setMobileOpen(false); }}
                                className='relative flex items-center justify-center w-[42px] h-[42px] rounded-full bg-[#f1f5f9] text-[#0891b2]'
                            >
                                <Bag className='w-[18px] h-[18px]' strokeWidth={2} />
                                {card_product_count > 0 && <span className='absolute -top-[3px] -right-[5px] w-5 h-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center'>{card_product_count}</span>}
                            </button>
                        </div>

                        <div className='flex items-center gap-3 text-[#334155] border-t border-[#f1efea] pt-4'>
                            <a href="#" aria-label='Instagram'><Instagram className='w-4 h-4' /></a>
                            <a href="#" aria-label='Facebook'><Facebook className='w-4 h-4' /></a>
                            <a href="#" aria-label='TikTok'><TikTok className='w-4 h-4' /></a>
                        </div>
                        <a href="mailto:hola@senorbigotes.com" className='flex items-center gap-2 text-sm text-[#64748b]'>
                            <Mail className='w-4 h-4' />hola@senorbigotes.com
                        </a>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Header;
